__turbopack_context__.v({
  "cardWrapper": "cardLC-module-scss-module__Nw8TPW__cardWrapper",
  "description": "cardLC-module-scss-module__Nw8TPW__description",
  "endNotes": "cardLC-module-scss-module__Nw8TPW__endNotes",
  "lcLogo": "cardLC-module-scss-module__Nw8TPW__lcLogo",
  "title": "cardLC-module-scss-module__Nw8TPW__title",
});
